import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import {
  FloatLabelType,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject, map, takeUntil } from 'rxjs';

import { CommonModule } from '@angular/common';
import { KeyService } from '@core/services/key.service';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'rh-filter',
    imports: [
        CommonModule,
        MatButtonModule,
        MatFormFieldModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule,
        RouterModule,
    ],
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterComponent implements OnInit, OnDestroy {
  private readonly keyService = inject(KeyService);

  readonly byAccount = new FormControl<boolean>(false);
  readonly showExpiredKeys = new FormControl<boolean>(false);
  readonly customerNumber = new FormControl<string | undefined>(undefined);
  readonly filter = new FormControl<string>('', []);

  readonly hideRequiredControl = new FormControl(false);
  readonly floatLabelControl = new FormControl('auto' as FloatLabelType);
  private readonly onDestroy = new Subject();

  ngOnInit(): void {
    if (
      Array.isArray(this.keyService.listKeysResponse()) &&
      this.keyService.listKeysResponse().length > 0
    )
      console.info('List of Key Items Already Exists');
    else this.fetchKeys();
    this.filter.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe((val) => this.keyService.filterKeys(val ?? ''));
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

  public showAccountInput(): number {
    if (!this.byAccount.value) return 6;
    else return 8;
  }

  protected readonly hideRequired = toSignal(
    this.hideRequiredControl.valueChanges
  );

  protected readonly floatLabel = toSignal(
    this.floatLabelControl.valueChanges.pipe(map((v) => v ?? 'auto')),
    { initialValue: 'auto' }
  );

  public fetchKeys() {
    this.keyService.getKeys(
      this.byAccount.value ?? false,
      this.customerNumber.value ?? '',
      this.showExpiredKeys.value ?? false
    );
  }
}
